import React, { useState, useEffect, useRef } from 'react';
import { isAdmin, isDoctor } from './helper/authRoles';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import {axiosInstance} from './helper/axiosConfig';
import './CreatePrescription.css'; // Assuming you have a specific CSS for CreateDoctor
import './CreateDoctor.css'; // Assuming you have a specific CSS for CreateDoctor
import './Dashboard.css'; // Consistent dashboard styling
import { faArrowLeft, faCamera, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'; // Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom'; // Import navigation hooks
import { specialities } from '../data/specialities';
import { districts } from '../data/districts'
import { thanasByDistrict } from '../data/thanasByDistrict';
// import { toast } from 'react-toastify';
import toast, { Toaster } from 'react-hot-toast';

const CreateDoctor = () => {
    const [formData, setFormData] = useState({
        title: 'Dr.',
        email: '',
        gender: '',
        full_name: '',
        mobile_number: '',
        bmdc_number: '',
        speaciality: '',
        bio: '',
        user: '',
        profile_pic: null, // For file upload
        visiting_card: null, // For file upload
        address_district: '',
        address_thana: '',
        address_chamber: '',
        password: '', // For user registration
        confirmPassword: '' // For password confirmation
    });

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    const [loading, setLoading] = useState(false); // Loading state for the form submission
    const [errors, setErrors] = useState({});
    const [avatarBgColor, setAvatarBgColor] = useState(getRandomColor());
    const [successMessage, setSuccessMessage] = useState('');
    const history = useNavigate(); // Hook for navigation
    const [availableThanas, setAvailableThanas] = useState([]); // State for available thanas based on district


  useEffect(() => {
    if(!isAdmin()) {
      history('/dashboard'); // Redirect after successful creation
      return;
    }
  }, []);


    // Handle form changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        if (name === 'address_district') {
          setAvailableThanas(thanasByDistrict[value] || []); // Get thanas for the selected district
        }
        setLoading(false);
    };

    // Handle file inputs
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];

        if (file && file.type.startsWith('image/')) {
            setFormData({
                ...formData,
                [name]: file,
            });
        } else {
            toast.error("Please upload a valid image file.");
        }
        setLoading(false);
    };

    const validatePassword = (password) => {
        const minLength = 8;
        const hasNumber = /\d/;
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;

        if (password.length < minLength || !hasNumber.test(password) || !hasSpecialChar.test(password)) {
            return false;
        }
        return true;
    };

    // Handle form submission (first register user, then create doctor)
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const userPayload = {
            email: formData.email,
            username: formData.email, // Assuming username is the same as email
            password1: formData.password,
            password2: formData.confirmPassword,
        };


        // if (!formData.full_name) setErrors({full_name: 'Full name is required.'});
        // if (!formData.email) setErrors({email: 'Email is required.'});
        // if (!formData.gender) setErrors({gender: 'Gender is required.'});
        // if (!formData.mobile_number) setErrors({mobile_number: 'Mobile number is required.'});
        // if (!formData.bmdc_number) setErrors({bmdc_number: 'BMDC number is required.'});
        // if (!formData.password) setErrors({password: 'Password is required'});


        if (!formData.full_name) {
          toast.error("Doctor name is required.")
          return;
        }
        if (!formData.email) {
          toast.error('Doctor email is required.');
          return;
        }
        if (!formData.gender) {
          toast.error('Doctor gender is required.');
          return;
        }
        if (!formData.mobile_number) {
          toast.error('Doctor mobile is required.');
          return;
        }
        if (!formData.bmdc_number) {
          toast.error('BMDC number is required.');
          return;
        }
        if (!formData.degree) {
          toast.error('Degree is required.');
          return;
        }
        if (!formData.password) {
          toast.error('Password is required.');
          return;
        }
        if (!formData.confirmPassword) {
          toast.error('Confirm password is required.');
          return;
        }
        if (formData.password !== formData.confirmPassword) {
            toast.error('Passwords do not match.');
            return;
        }
        if (!validatePassword(formData.password)) {
            toast.error('Password must be at least 8 characters long and include numbers and special characters.');
            return;
        }

        // Validate password and confirm password match
        // if (formData.password !== formData.confirmPassword) {
        //     setErrors({ password: 'Passwords do not match.' });
        //     return;
        // }
        // if (!validatePassword(formData.password)) {
        //     setErrors({ password: 'Password must be at least 8 characters long and include numbers and special characters.' });
        //     return;
        // }
        // if (!formData.full_name) toast.error('Full name is required.', {autoClose: 3000,});
        // if (!formData.email) toast.error('Email is required.', {autoClose: 3000,});
        // if (!formData.gender) toast.error('Gender is required.', {autoClose: 3000,});
        // if (!formData.mobile_number) toast.error('Mobile number is required.', {autoClose: 3000,});
        // if (!formData.bmdc_number) toast.error('BMDC number is required.', {autoClose: 3000,});
        // if (!formData.password) toast.error('Password is required.', {autoClose: 3000,});
        // if (formData.password !== formData.confirmPassword) toast.error('Passwords do not match.', {autoClose: 3000,});


        try {
            // Step 1: Register the user
            const userResponse = await axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/auth/registration/`, userPayload);
            const userId = userResponse.data.user_id; // Assuming the response contains the user ID
            // Step 2: Register the doctor using the newly created user ID
            const doctorFormData = new FormData();
            for (let key in formData) {
                if (formData[key] !== null && key !== 'password' && key !== 'confirmPassword') {
                    doctorFormData.append(key, formData[key]);
                }
            }
            //console.log("this is the form data = ", doctorFormData);
            doctorFormData.append('user', userId); // Link doctor to user
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            };
            if (userId){
              const doctorResponse = await axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor/`, doctorFormData, config);
              if(doctorResponse && doctorResponse.data && doctorResponse.data.id){
                const doctorSetting = {
                    address_district: formData.address_district,
                    address_thana: formData.address_thana, // Assuming username is the same as email
                    signature: formData.signature,
                    doctor: doctorResponse.data.id,
                };
                if (schedules && schedules.length && schedules.length > 0) {
                  await Promise.all(schedules.map(schedule => {
                      return axiosInstance.post('/api/schedule/', {
                          doctor: doctorResponse.data.id,
                          day: schedule.day,
                          from_time: schedule.from_time,
                          to_time: schedule.to_time
                      });
                  }));
                }

                // const doctorSettingResponse = await axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor-setting/`, doctorSetting, config);
                await toast.promise(
                    axiosInstance.post(`${process.env.REACT_APP_AXIOS_BASE_URL}/api/doctor-setting/`, doctorSetting, config),
                    {
                      loading: 'Creating doctor...',
                      success: <b>Doctor created successfully!</b>,
                      error: <b>Failed to creating doctor.</b>,
                    }
                );


                // if(doctorSettingResponse){
                  setLoading(false);
                  // toast.success("Doctor's profile has been added successfully.");
                  history('/doctor-history'); // Redirect after successful creation
                // }
              }
            }
            //setSuccessMessage('Doctor created successfully!');
            setErrors({});
        } catch (error) {
          if (error.response && error.response.data) {
              setErrors(error.response.data); // Set field-level errors
              const errorMessage = error.response.data.message || 'An error occurred. Please try again.';
              toast.error(errorMessage); // Display a global error
          } else {
              toast.error('Something went wrong. Please try again later.');
          }
        }
    };


    //Schedule JSX
    const formatTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(':'); // Split the time string
        const date = new Date();
        date.setHours(hours, minutes);

        return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }); // 12-hour format
    };

    const [scheduleForm, setScheduleForm] = useState({
        day: '',
        from_time: '',
        to_time: ''
    });

    const [schedules, setSchedules] = useState([]);  // Store all added schedules

    // Handle changes in schedule form inputs
    const handleScheduleChange = (e) => {
        const { name, value } = e.target;
        setScheduleForm({
            ...scheduleForm,
            [name]: value,
        });
    };

    // Add schedule entry
    const addSchedule = () => {
        if (!scheduleForm.day || !scheduleForm.from_time || !scheduleForm.to_time) {
            toast.error("Please fill out all fields before adding a schedule.");
            return;
        }

        const newSchedule = {
            day: scheduleForm.day,
            from_time: scheduleForm.from_time,
            to_time: scheduleForm.to_time
        };

        setSchedules((prevSchedules) => [...prevSchedules, newSchedule]);

        // Reset the form
        setScheduleForm({ day: '', from_time: '', to_time: '' });
    };

    // Remove schedule entry
    const removeSchedule = (index) => {
        setSchedules(schedules.filter((_, i) => i !== index));
    };

    // Fetch all schedules for the doctor on component mount
    //Finish Schedule JSX



    return (
        <div className="dashboard-container">
            <Sidebar /> {/* Sidebar component */}
            <div className="dashboard-main">
                <Header /> {/* Header component */}
                <div className="content-box create-doctor"> {/* Matching structure with patient page */}

                    {/* Doctor Creation Form */}
                    <div className="patient-details-container create-patient">

                        {/* Doctor Profile Header */}

                        <div className="patient-header">
                            <div className="back-icon-wrapper">
                                <Link to="/doctor-history">
                                    <FontAwesomeIcon icon={faArrowLeft} className="back-icon" />
                                </Link>
                            </div>
                            <div className="center-content">
                                <h2 className="profile-name">Create New Doctor</h2>
                                <div className="profile-picture-wrapper">
                                    <label htmlFor="profile-pic-input">
                                        <div
                                            className="profile-picture"
                                            style={{
                                                backgroundColor: avatarBgColor,
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '50%',
                                                backgroundImage: formData.profile_pic ? `url(${URL.createObjectURL(formData.profile_pic)})` : 'none',
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {!formData.profile_pic && <FontAwesomeIcon icon={faCamera} className="camera-icon" />}
                                        </div>
                                    </label>
                                    <input
                                        id="profile-pic-input"
                                        type="file"
                                        name="profile_pic"
                                        accept="image/*"
                                        style={{ display: 'none' }} // Hide the file input
                                        onChange={handleFileChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="patient-info-div">
                            <div className="patient-info">
                              <form onSubmit={handleSubmit} className="patient-info-form create-prescription"> {/* Doctor form */}

                                  {/* Title */}
                                  {errors.profile_pic && <span className="text-danger">{errors.profile_pic}</span>}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="title"
                                          value={formData.title}
                                          onChange={handleChange}
                                      />
                                      <label>Title</label>
                                      {errors.title && <span className="text-danger">{errors.title}</span>}
                                  </div>


                                  {/* Full Name */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="full_name"
                                          placeholder="Enter Doctor'sFull Name"
                                          value={formData.full_name}
                                          onChange={handleChange}

                                      />
                                      <label>Full Name <sup>*</sup></label>
                                      {errors.full_name && <span className="text-danger">{errors.full_name}</span>}
                                  </div>

                                  {/* Speciality */}
                                  <div className="form-group row-double">
                                      <select
                                        name="speaciality"
                                        value={formData.speaciality}
                                        onChange={handleChange}

                                      >
                                        <option value="">Select Speaciality</option>
                                        {specialities.map((speaciality) => (
                                          <option key={speaciality.value} value={speaciality.label}>
                                            {speaciality.label}
                                          </option>
                                        ))}
                                      </select>
                                      <label>Speciality <sup>*</sup></label>
                                      {errors.speciality && <span className="text-danger">{errors.speciality}</span>}
                                  </div>


                                  {/* Gender */}
                                  <div className="form-group row-double">
                                      <select
                                          name="gender"
                                          value={formData.gender}
                                          placeholder="Select Gender"
                                          onChange={handleChange}
                                          required
                                      >
                                          <option value="">Select Gender</option>
                                          <option value="male">Male</option>
                                          <option value="female">Female</option>
                                          <option value="other">Other</option>
                                      </select>
                                      <label>Gender <sup>*</sup></label>
                                      {errors.gender && <span className="text-danger">{errors.gender}</span>}
                                  </div>

                                  {/* Email */}
                                  <div className="form-group">
                                      <input
                                          type="email"
                                          name="email"
                                          placeholder="Enter Email Address"
                                          value={formData.email}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Email <sup>*</sup></label>
                                      {errors.email || errors.username && <span className="text-danger">{errors.email} {errors.username}</span>}
                                  </div>


                                  {/* Mobile Number */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="mobile_number"
                                          placeholder="Enter Mobile Number e.g. 01xxx.."
                                          value={formData.mobile_number}
                                          pattern="[0-9]{11}"
                                          title="Please enter a valid 11-digit Bangladeshi mobile number starting with 01."
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Mobile Number <sup>*</sup></label>
                                      {errors.mobile_number && <span className="text-danger">{errors.mobile_number}</span>}
                                  </div>

                                  {/* BMDC Number */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="bmdc_number"
                                          placeholder="Enter BMDC Number"
                                          value={formData.bmdc_number}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>BMDC Number <sup>*</sup></label>
                                      {errors.bmdc_number && <span className="text-danger">{errors.bmdc_number}</span>}
                                  </div>

                                  {/* Degree */}
                                  <div className="form-group">
                                      <input
                                          type="text"
                                          name="degree"
                                          placeholder="Enter Degrees with commas"
                                          value={formData.degree}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Degree <sup>*</sup></label>
                                      {errors.degree && <span className="text-danger">{errors.degree}</span>}
                                  </div>

                                  {/* Bio */}
                                  <div className="form-group bio row-double">
                                      <textarea
                                          name="bio"
                                          value={formData.bio}
                                          onChange={handleChange}
                                          placeholder="Enter Doctor's experience"
                                          rows="3"
                                      ></textarea>
                                      <label>Experience</label>
                                      {errors.bio && <span className="text-danger">{errors.bio}</span>}
                                  </div>

                                  <h4>Address</h4>
                                    <div className="form-row row-double">
                                      <div className="form-group">
                                        <select
                                          name="address_district"
                                          value={formData.address_district}
                                          onChange={handleChange}
                                        >
                                          <option value="">Select District</option>
                                          {districts.map((district) => (
                                            <option key={district.name} value={district.name}>
                                              {district.name}
                                            </option>
                                          ))}
                                        </select>
                                        <label>District</label>
                                        {errors.address_district && <span className="text-danger">{errors.address_district}</span>}
                                      </div>

                                      <div className="form-group">
                                        <select
                                          name="address_thana"
                                          value={formData.address_thana}
                                          onChange={handleChange}
                                        >
                                          <option value="">Select Thana</option>
                                          {availableThanas.map((thana) => (
                                            <option key={thana} value={thana}>
                                              {thana}
                                            </option>
                                          ))}
                                        </select>
                                        <label>Thana</label>
                                        {errors.address_thana && <span className="text-danger">{errors.address_thana}</span>}
                                      </div>
                                    </div>

                                    {/* address_chamber */}
                                    <div className="form-group bio row-double">
                                        <textarea
                                            name="address_chamber"
                                            value={formData.address_chamber}
                                            onChange={handleChange}
                                            placeholder="Enter Doctor's Chamber Address"
                                            rows="3"
                                        ></textarea>
                                        <label>Chamber Address</label>
                                        {errors.address_chamber && <span className="text-danger">{errors.address_chamber}</span>}
                                    </div>

                                  {/* Visiting Card Upload */}
                                  <h4>Uploads</h4>
                                  <div className="form-group upload">
                                      <input
                                          type="file"
                                          placeholder="Upload Visiting Card"
                                          name="visiting_card"
                                          onChange={handleFileChange}
                                          className="form-control-file"
                                          accept="image/*"
                                      />
                                      <label>Upload Visiting Card <sub>(only jpg or png, no special character)</sub></label>
                                      {errors.visiting_card && <span className="text-danger">{errors.visiting_card}</span>}
                                  </div>
                                  <div className="form-group upload">
                                      <input
                                          type="file"
                                          name="signature"
                                          onChange={handleFileChange}
                                          placeholder="Upload Signature"
                                          className="form-control-file"
                                          accept="image/*"
                                      />
                                      <label>Upload Signature <sub>(only jpg or png, no special character)</sub></label>
                                      {errors.signature && <span className="text-danger">{errors.signature}</span>}
                                  </div>

                                  {/* Availability Schedule */}
                                    <h4>Availability</h4>
                                    <div className="availability-section">
                                        <div className="schedule-form">
                                            <select name="day" value={scheduleForm.day} onChange={handleScheduleChange} className="day-dropdown">
                                                <option value="">Select Day</option>
                                                {["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
                                                    <option value={day} key={day}>{day}</option>
                                                ))}
                                            </select>

                                            <input
                                                type="time"
                                                name="from_time"
                                                value={scheduleForm.from_time}
                                                onChange={handleScheduleChange}
                                                className="time-field"
                                            />

                                            <input
                                                type="time"
                                                name="to_time"
                                                value={scheduleForm.to_time}
                                                onChange={handleScheduleChange}
                                                className="time-field"
                                            />

                                           {/*  <a onClick={addSchedule} className="add-schedule-button">
                                                <FontAwesomeIcon icon={faPlus} />
                                            </a>
                                            */}
                                        </div>

                                        <div className="schedule-list">
                                            {schedules.map((schedule, index) => (
                                                <div key={index} className="schedule-entry">
                                                    <span>{schedule.day} -  {formatTime(schedule.from_time)} to  {formatTime(schedule.to_time)}</span>
                                                    <a onClick={() => removeSchedule(index)} className="remove-schedule-button">
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                     <div className='form-group float-right mb-0'>
                                      <button
                                        type='button'
                                        onClick={addSchedule}
                                        className='btn btn-primary btn-lg btn-sub medication'
                                      >
                                        + Add Schedule
                                      </button>
                                    </div>

                                  {/* Finish Availability Schedule */}

                                  <h4>Credentials</h4>
                                  {/* Password */}
                                  <div className="form-group">
                                      <input
                                          type="password"
                                          name="password"
                                          placeholder="Enter Password"
                                          value={formData.password}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Password *</label>
                                      {errors.password1 && <span className="text-danger">{errors.password1}</span>}
                                  </div>

                                  {/* Confirm Password */}
                                  <div className="form-group">
                                      <input
                                          type="password"
                                          name="confirmPassword"
                                          placeholder="Enter Confirm Password"
                                          value={formData.confirmPassword}
                                          onChange={handleChange}
                                          required
                                      />
                                      <label>Confirm Password *</label>
                                      {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword}</span>}
                                  </div>

                                  {/* Submit Button */}
                                  <div className="form-group submit-button-container">
                                    <button type="submit" className="submit-btn" disabled={loading}>
                                      {loading ? 'Creating...' : '+ Create Doctor'}
                                    </button>
                                  </div>

                                  {/* Success Message */}
                                  {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                              </form>
                            </div>
                          </div>
                    </div>
                </div>
                <div className="footer-content">
                    {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
                </div>
            </div>
        </div>
    );
};

export default CreateDoctor;
